export default __webpack_public_path__ + "static/media/sin_tacc.69b5d5e3.svg";